import { queryKeyFactory } from "@l2r-front/l2r-query"

export const RISK_ZONES_ROOT_QUERY_KEY = "riskZones"

export const riskZonesQueryKeys = queryKeyFactory(RISK_ZONES_ROOT_QUERY_KEY, {
    layer: (filters = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "layer", filters],
    feature: (featureId, params = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "feature", featureId, params],
    grades: (filters = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "grades", filters],
    project: (filters = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "project", filters],
    surveys: (filters = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "surveys", filters],
    vehicleStats: (filters = {}) => [RISK_ZONES_ROOT_QUERY_KEY, "vehicleStats", filters],
})
